var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.7046 0L5.29559 1.3646e-07L5.29559 10.012L7.875 7.48132L9 8.58505L4.5 13L0 8.58505L1.125 7.48132L3.7046 10.0122L3.7046 0Z","fill":"white"}));
}

ArrowDown.defaultProps = {"width":"9","height":"13","viewBox":"0 0 9 13","fill":"none"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
